import Immutable from 'immutable';

// constants
import { APPOINTMENT_CURRENT_REP_FETCH } from '../constants/appointmentTypes';

// lib
import httpReducer from '../lib/httpReducer';

const sort = function(map, action) {
  const normalized  = action.payload.normalized || {};
  const entities    = normalized.entities || {};
  const currentRepAppointments      = entities.currentRepAppointments;

  if (currentRepAppointments) {
    const sortedAppointments     = Immutable.fromJS(currentRepAppointments).sortBy((item) => item.get('from')).sortBy((item) => item.get('scheduledOn'));

    map.set('data', sortedAppointments);
  }
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case APPOINTMENT_CURRENT_REP_FETCH: return httpReducer(state, action, sort);
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/currentRepAppointments.js